import React from 'react';
import { Card } from '../../components/ui/Card';
export function Checkout() {
  return <div className="space-y-4 max-w-3xl" data-id="element-1647">
      <div className="rounded-xl px-6 py-5 text-white" style={{
      backgroundColor: '#4A2D8F'
    }} data-id="element-1648">
        <h1 className="text-2xl font-extrabold tracking-tight mb-1" data-id="element-1649">
          Checkout
        </h1>
        <p className="text-purple-200 text-sm" data-id="element-1650">
          Complete your purchase to begin your courses.
        </p>
      </div>
      <div className="rounded-xl p-6 space-y-4" style={{
      backgroundColor: '#FDF6E3'
    }} data-id="element-1651">
        <p className="text-sm text-slate-600" data-id="element-1652">Your cart is now empty</p>

        {/* Contact Information */}
        <Card className="overflow-hidden rounded-none border-slate-300" data-id="element-1653">
          <div style={{
          backgroundColor: '#4A2D8F'
        }} className="px-4 py-2" data-id="element-1654">
            <h2 className="text-white text-sm font-semibold text-center" data-id="element-1655">
              Contact Information
            </h2>
          </div>
          <div className="p-0" data-id="element-1656">
            <table className="w-full text-sm" data-id="element-1657">
              <tbody className="divide-y divide-slate-200" data-id="element-1658">
                {[{
                label: 'First Name :',
                value: 'Dana'
              }, {
                label: 'Last Name :',
                value: 'Kichen'
              }, {
                label: 'Company :',
                value: ''
              }, {
                label: 'Phone :',
                value: '4803910222'
              }, {
                label: 'Fax :',
                value: ''
              }, {
                label: 'Website :',
                value: ''
              }].map(row => <tr key={row.label} className="border-b border-slate-200" data-id="element-1659">
                    <td className="px-3 py-1.5 text-slate-600 w-32 bg-slate-50" data-id="element-1660">
                      {row.label}
                    </td>
                    <td className="px-3 py-1.5" data-id="element-1661">
                      <input type="text" defaultValue={row.value} className="w-full border border-slate-300 rounded px-2 py-0.5 text-sm focus:outline-none focus:ring-1 focus:ring-purple-400" data-id="element-1662" />
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </Card>

        {/* Billing Address */}
        <Card className="overflow-hidden rounded-none border-slate-300" data-id="element-1663">
          <div style={{
          backgroundColor: '#4A2D8F'
        }} className="px-4 py-2" data-id="element-1664">
            <h2 className="text-white text-sm font-semibold text-center" data-id="element-1665">
              Billing Address
            </h2>
          </div>
          <div className="p-0" data-id="element-1666">
            <table className="w-full text-sm" data-id="element-1667">
              <tbody className="divide-y divide-slate-200" data-id="element-1668">
                {[{
                label: 'Address :',
                value: '14793 N. 90th Place'
              }, {
                label: 'City :',
                value: 'Scottsdale'
              }, {
                label: 'State :',
                value: 'AZ'
              }, {
                label: 'Zip/Postal Code :',
                value: '85260'
              }].map(row => <tr key={row.label} className="border-b border-slate-200" data-id="element-1669">
                    <td className="px-3 py-1.5 text-slate-600 w-36 bg-slate-50" data-id="element-1670">
                      {row.label}
                    </td>
                    <td className="px-3 py-1.5" data-id="element-1671">
                      <input type="text" defaultValue={row.value} className="w-full border border-slate-300 rounded px-2 py-0.5 text-sm focus:outline-none focus:ring-1 focus:ring-purple-400" data-id="element-1672" />
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </Card>

        {/* Update button */}
        <div data-id="element-1673">
          <button className="px-4 py-1.5 text-white text-sm font-bold rounded" style={{
          backgroundColor: '#2E7D32'
        }} data-id="element-1674">
            Update
          </button>
        </div>

        {/* Credit Card Section */}
        <div className="space-y-3 text-sm" data-id="element-1675">
          <div className="flex items-end gap-4 flex-wrap" data-id="element-1676">
            <div data-id="element-1677">
              <label className="block text-slate-700 mb-1" data-id="element-1678">
                Credit Card Number
              </label>
              <input type="text" className="border border-slate-300 rounded px-2 py-1 text-sm w-44 focus:outline-none focus:ring-1 focus:ring-purple-400" data-id="element-1679" />
            </div>
            <div data-id="element-1680">
              <label className="block text-slate-700 mb-1" data-id="element-1681">Exp.</label>
              <div className="flex gap-1" data-id="element-1682">
                <select className="border border-slate-300 rounded px-2 py-1 text-sm focus:outline-none" data-id="element-1683">
                  {['Month', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'].map(m => <option key={m} data-id="element-1684">{m}</option>)}
                </select>
                <select className="border border-slate-300 rounded px-2 py-1 text-sm focus:outline-none" data-id="element-1685">
                  {['Year', '2025', '2026', '2027', '2028', '2029', '2030'].map(y => <option key={y} data-id="element-1686">{y}</option>)}
                </select>
              </div>
            </div>
            <div data-id="element-1687">
              <label className="block text-slate-700 mb-1" data-id="element-1688">CCV</label>
              <div className="flex items-center gap-1" data-id="element-1689">
                <input type="text" className="border border-slate-300 rounded px-2 py-1 text-sm w-16 focus:outline-none focus:ring-1 focus:ring-purple-400" data-id="element-1690" />
                <div className="w-5 h-5 rounded-full bg-blue-500 text-white text-xs flex items-center justify-center font-bold cursor-help" title="The 3-digit security code on the back of your card" data-id="element-1691">
                  ?
                </div>
              </div>
            </div>
          </div>

          <div className="flex gap-4 flex-wrap" data-id="element-1692">
            <div className="flex-1 min-w-32" data-id="element-1693">
              <label className="block text-slate-700 mb-1" data-id="element-1694">First Name</label>
              <input type="text" defaultValue="Dana" className="w-full border border-slate-300 rounded px-2 py-1 text-sm focus:outline-none focus:ring-1 focus:ring-purple-400" data-id="element-1695" />
            </div>
            <div className="flex-1 min-w-32" data-id="element-1696">
              <label className="block text-slate-700 mb-1" data-id="element-1697">Last Name</label>
              <input type="text" defaultValue="Kichen" className="w-full border border-slate-300 rounded px-2 py-1 text-sm focus:outline-none focus:ring-1 focus:ring-purple-400" data-id="element-1698" />
            </div>
          </div>

          <div data-id="element-1699">
            <label className="block text-slate-700 mb-1" data-id="element-1700">Email</label>
            <input type="email" defaultValue="reggieborris@yahoo.com" className="w-full border border-slate-300 rounded px-2 py-1 text-sm focus:outline-none focus:ring-1 focus:ring-purple-400" data-id="element-1701" />
          </div>

          <div className="flex gap-4 flex-wrap" data-id="element-1702">
            <div className="flex-1 min-w-40" data-id="element-1703">
              <label className="block text-slate-700 mb-1" data-id="element-1704">Address</label>
              <input type="text" defaultValue="14793 N. 90th Place" className="w-full border border-slate-300 rounded px-2 py-1 text-sm focus:outline-none focus:ring-1 focus:ring-purple-400" data-id="element-1705" />
            </div>
            <div className="flex-1 min-w-28" data-id="element-1706">
              <label className="block text-slate-700 mb-1" data-id="element-1707">City</label>
              <input type="text" defaultValue="Scottsdale" className="w-full border border-slate-300 rounded px-2 py-1 text-sm focus:outline-none focus:ring-1 focus:ring-purple-400" data-id="element-1708" />
            </div>
          </div>

          <div className="flex gap-4 flex-wrap" data-id="element-1709">
            <div className="w-16" data-id="element-1710">
              <label className="block text-slate-700 mb-1" data-id="element-1711">State</label>
              <input type="text" defaultValue="AZ" className="w-full border border-slate-300 rounded px-2 py-1 text-sm focus:outline-none focus:ring-1 focus:ring-purple-400" data-id="element-1712" />
            </div>
            <div className="w-24" data-id="element-1713">
              <label className="block text-slate-700 mb-1" data-id="element-1714">Zip Code</label>
              <input type="text" defaultValue="85260" className="w-full border border-slate-300 rounded px-2 py-1 text-sm focus:outline-none focus:ring-1 focus:ring-purple-400" data-id="element-1715" />
            </div>
            <div className="w-24" data-id="element-1716">
              <label className="block text-slate-700 mb-1" data-id="element-1717">Country</label>
              <input type="text" defaultValue="US" className="w-full border border-slate-300 rounded px-2 py-1 text-sm focus:outline-none focus:ring-1 focus:ring-purple-400" data-id="element-1718" />
            </div>
          </div>

          <div className="flex gap-6 items-start" data-id="element-1719">
            <div className="flex-1" data-id="element-1720">
              <label className="block text-slate-700 mb-1" data-id="element-1721">
                Customer Notes
              </label>
              <textarea rows={4} className="w-full border border-slate-300 rounded px-2 py-1 text-sm focus:outline-none focus:ring-1 focus:ring-purple-400" data-id="element-1722" />
            </div>
            <div className="text-center pt-4" data-id="element-1723">
              <p className="text-xs text-slate-600 mb-1" data-id="element-1724">
                Credit Card Processing
              </p>
              <div className="w-16 h-16 border border-slate-300 rounded flex items-center justify-center bg-slate-50" data-id="element-1725">
                <span className="text-xs text-slate-400 text-center leading-tight" data-id="element-1726">
                  Authorize.Net
                </span>
              </div>
              <button className="mt-1 text-xs text-blue-600 hover:underline" data-id="element-1727">
                Credit Card Processing
              </button>
            </div>
          </div>
        </div>

        {/* Buy button */}
        <div className="flex items-center gap-3" data-id="element-1728">
          <button className="px-4 py-1.5 text-white text-sm font-bold rounded" style={{
          backgroundColor: '#2E7D32'
        }} data-id="element-1729">
            Buy
          </button>
          <span className="text-sm font-medium" style={{
          color: '#CC0000'
        }} data-id="element-1730">
            Please click BUY button only ONCE to avoid a duplicate order
          </span>
        </div>
      </div>
    </div>;
}